// Inner photo frame after the 8px border on the 360×519 box.
const PHOTO_FRAME_WIDTH = 344
const PHOTO_FRAME_HEIGHT = 503
const LOGO_BOX_WIDTH = 560
const LOGO_BOX_HEIGHT = 112

function fittedImageRect (sourceWidth, sourceHeight, boxWidth, boxHeight, fit, alignX) {
  if (!sourceWidth || !sourceHeight || !boxWidth || !boxHeight) {
    return { x: 0, y: 0, width: 0, height: 0 }
  }

  const widthScale = boxWidth / sourceWidth
  const heightScale = boxHeight / sourceHeight
  const scale = fit === 'contain' ? Math.min(widthScale, heightScale) : Math.max(widthScale, heightScale)
  const width = sourceWidth * scale
  const height = sourceHeight * scale

  return {
    x: alignX === 'left' ? 0 : (boxWidth - width) / 2,
    y: (boxHeight - height) / 2,
    width: width,
    height: height
  }
}

function imageBoxSize (image, fallbackWidth, fallbackHeight) {
  const width = image && image.clientWidth ? image.clientWidth : fallbackWidth
  const height = image && image.clientHeight ? image.clientHeight : fallbackHeight
  return { width: width, height: height }
}

module.exports = {
  PHOTO_FRAME_WIDTH,
  PHOTO_FRAME_HEIGHT,
  LOGO_BOX_WIDTH,
  LOGO_BOX_HEIGHT,
  fittedImageRect,
  imageBoxSize
}
